module.exports = __webpack_public_path__ + "img/yahoo-logo.f1e6cc38.svg";